import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { useCart } from "@/context/CartContext";
import { useCurrency } from "@/context/CurrencyContext";
import { useWishlist } from "@/context/WishlistContext";
import { toast } from "sonner";
import { Heart } from "lucide-react";

export const ProductCard = ({ product }) => {
  const { tl, t } = useLang();
  const { addItem } = useCart();
  const { format } = useCurrency();
  const { has, toggle } = useWishlist();

  return (
    <div data-testid={`product-card-${product.id}`} className="group fade-up">
      <Link to={`/product/${product.id}`} className="block overflow-hidden bg-white border border-[#EAE6E1] relative">
        <button
          data-testid={`wishlist-toggle-${product.id}`}
          onClick={(e) => { e.preventDefault(); toggle(product.id); }}
          className="absolute top-3 right-3 z-10 w-9 h-9 flex items-center justify-center bg-white/80 backdrop-blur hover:bg-white transition-colors"
        >
          <Heart className={`w-4 h-4 ${has(product.id) ? "fill-[#C5A880] text-[#C5A880]" : "text-[#1A1F2C]"}`} strokeWidth={1.5} />
        </button>
        <div className="aspect-[4/5] overflow-hidden bg-[#F0EAE1]">
          <img
            src={product.images?.[0]}
            alt={tl(product.name)}
            className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
        </div>
      </Link>
      <div className="pt-4 flex flex-col gap-2">
        <Link to={`/product/${product.id}`}>
          <h3 className="font-serif-display text-xl text-[#1A1F2C] leading-tight hover:text-[#C5A880] transition-colors duration-300">
            {tl(product.name)}
          </h3>
        </Link>
        <span className="text-sm text-[#6B7280]">{format(product.price)}</span>
        <button
          data-testid={`add-to-cart-${product.id}`}
          onClick={() => { addItem(product); toast.success(t("added_to_cart")); }}
          className="mt-1 text-xs tracking-luxe uppercase text-[#1A1F2C] border-b border-[#1A1F2C] pb-1 self-start hover:text-[#C5A880] hover:border-[#C5A880] transition-colors duration-300"
        >
          {t("add_to_cart")}
        </button>
      </div>
    </div>
  );
};
